(() => {
  const updatePromoLinks = () => {
    const isLocalPreview = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
    if (!isLocalPreview) return;

    document.querySelectorAll('[data-promo-discount-link]').forEach((link) => {
      link.href = link.dataset.previewUrl || '/collections/all';
      link.removeAttribute('data-promo-discount-link');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePromoLinks);
  } else {
    updatePromoLinks();
  }

  document.addEventListener('shopify:section:load', updatePromoLinks);
})();
